import React from 'react';
import './App.less';
import Pages from './pages/page'
// import Footer from './components/footer'
function App() {
  return (
    <div className="App">
      <Pages />
    </div>
  );
}

export default App;
